import { Submit as SubmitIcon } from "./../../Components/Icon";
import Submit from "./../../Pages/Submit";

const navigation = () => ({
  header: "Submit",
  links: [
    {
      text: "Submit",
      icon: SubmitIcon,
      route: "submit",
      component: Submit,
      preProposal:true
    },
  ],
});

export default navigation;
